/**
 * Constants related to completion tracking and filtering
 */

/**
 * ALS-related diagnoses that qualify for completion tracking
 */
export const ALS_DIAGNOSES = ['als', 'als-probable', 'pls'] as const

/**
 * Role identifier for patient users
 */
export const PATIENT_ROLE = 'patient' as const

/**
 * UI dimensions for completion filters
 */
export const STUDY_FILTER_MAX_WIDTH = '300px' as const
